import { AccountingSyncBadge } from '@/components/AccountingSyncBadge'
import { DetailPage } from '@/components/templates/detail-page'
import { Alert } from '@/components/ui/alert'
import type { Invoice } from '@/pages/InvoicesPage.types'

export function InvoicePageState({ loading, onBack }: { loading: boolean; onBack: () => void }) {
  return (
    <DetailPage title="Invoice" backHref="#" backLabel="Invoices" onBack={onBack}>
      {loading ? (
        <p className="text-body-sm text-muted-foreground" role="status">
          Loading Invoice...
        </p>
      ) : (
        <Alert>Invoice unavailable</Alert>
      )}
    </DetailPage>
  )
}

export function AccountingSyncSummary({ invoice }: { invoice: Invoice }) {
  if (!invoice.accounting_sync_state) return null

  return (
    <div className="flex items-center gap-2 text-body-sm">
      <span className="text-muted-foreground">Accounting</span>
      <AccountingSyncBadge
        state={invoice.accounting_sync_state}
        detail={invoice.accounting_sync_detail}
      />
      {invoice.accounting_sync_detail && (
        <span className="text-muted-foreground">{invoice.accounting_sync_detail}</span>
      )}
    </div>
  )
}
